import { AutoComplete, Button, Card, Col, Form, Image, Input, List, message, Rate, Row, Select, Upload } from 'antd'
import React, { useEffect, useState } from 'react'
import Get from '../services/Get';
import { PlusOutlined, UploadOutlined } from '@ant-design/icons';
import ReactGoogleAutocomplete from 'react-google-autocomplete';
import Post from '../services/Post';
import { useNavigate } from 'react-router-dom';

const ListBusiness = () => {
    const [form] = Form.useForm();
    const [listingCategory, setListingCategory] = useState([]);
    const [subCategory, setSubCategory] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState([]);
    const [services, setServices] = useState([]);
    const [logo, setLogo] = useState();
    const [address, setAddress] = useState("");
    const [latitude, setLatitude] = useState(null);
    const [longitude, setLongitude] = useState(null);
    const [city, setCity] = useState("");
    const [pincode, setPincode] = useState("");
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [url, setUrl] = useState();
    const [aadharFront, setAadharFront] = useState();
    const [aadharBack, setAadharBack] = useState();
    const [panCard, setPanCard] = useState();
    const [shopPhotos, setShopPhotos] = useState([]);

    const navigate = useNavigate();

    const getListingCategory = () => {
        Get.ListingCategory("")
            .then((res) => {
                console.log('res ===', res.url);
                setListingCategory(res.data);
            })
            .catch((error) => {
                console.error("Error fetching listing categories:", error);
            })
    };

    const getData = () => {
        // Prevent duplicate calls
        if (loading) return;

        setLoading(true);

        Get.ListingByUser()
            .then((res) => {
                console.log('business res ===', res.data);
                setData(res.data);
                setUrl(res.url);
            })
            .catch((err) => {
                console.error("Error fetching data:", err);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const handleCategoryChange = (categoryId) => {
        // Find the selected category
        const selected = listingCategory.find(cat => cat.id === categoryId);

        // Update subCategory state with child categories or empty array if none
        setSubCategory(selected?.child || []);
        setServices(selected?.services || []);
        setSelectedCategory(categoryId);
    };

    const handleSubCategoryChange = (subCategoryId) => {
        // Find the selected category
        const selected = subCategory.find(cat => cat.id === subCategoryId);

        setServices(selected?.services || []);
    };

    const normFile = (e, setFile) => {
        console.log("Upload event:", e);

        const fileList = Array.isArray(e) ? e : e?.fileList;
        const file = fileList?.[fileList.length - 1]?.originFileObj;

        if (file) {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                const base64String = reader.result.split(',')[1];
                console.log("Base64:", base64String);
                setFile(base64String);
            };
        }

        return file ? [file] : [];
    };

    const normMultipleFiles = (e) => {
        console.log("Upload event:", e);
        const fileList = Array.isArray(e) ? e : e?.fileList || [];

        const filesBase64 = [];

        fileList.forEach((fileObj) => {
            const file = fileObj.originFileObj;
            if (file) {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => {
                    const base64String = reader.result.split(',')[1];
                    filesBase64.push(base64String);
                    setShopPhotos([...filesBase64]);
                };
            }
        });

        return fileList;
    };

    const handlePlaceSelected = (place) => {
        if (place.geometry) {
            setLatitude(place.geometry.location.lat());
            setLongitude(place.geometry.location.lng());
        }

        const formattedAddress = place.formatted_address;
        setAddress(formattedAddress);
        form.setFieldsValue({ address: formattedAddress }); // Update Ant Form value

        // Extract city & pincode
        const addressComponents = place.address_components;
        const cityComponent = addressComponents.find((component) =>
            component.types.includes("locality")
        ) || addressComponents.find((component) =>
            component.types.includes("administrative_area_level_1")
        );

        if (cityComponent) {
            setCity(cityComponent.long_name);
            form.setFieldsValue({ city: cityComponent.long_name }); // Update form
        }

        const pincodeComponent = addressComponents.find((component) =>
            component.types.includes("postal_code")
        );

        if (pincodeComponent) {
            setPincode(pincodeComponent.long_name);
            form.setFieldsValue({ pincode: pincodeComponent.long_name }); // Update form
        }
    };

    const handleSubmit = (values) => {
        console.log('values', values);

        const formData = {
            category_id: values.category_id,
            sub_category_id: values.sub_category_id,
            business_name: values.business_name,
            logo,
            description: values.description,
            contact_name: values.contact_name,
            contact_no: values.contact_no,
            establed_at: values.establed_at,
            address: address,
            latitude: latitude,
            longitude: longitude,
            city: city,
            pincode: pincode,
            discount: values.discount,
            services: values.services,
            aadhar_front: aadharFront,
            aadhar_back: aadharBack,
            pan_card: panCard,
            shop_photos: shopPhotos,
        };

        console.log('data to send', formData);

        setLoading(true);
        Post.ListBusiness(formData).then((res) => {
            console.log("response = = ", res);
            if (res.error) {
                message.error(res.message);
            }
            message.success(res.message);
        }).catch((error) => {
            console.error("Error fetching coupons", error);
            message.error('Something went wrong');
        }).finally(() => {
            setLoading(false);
        });
    }

    const years = Array.from({ length: 124 }, (_, i) => new Date().getFullYear() - i);

    useEffect(() => {
        getListingCategory();
        getData();
    }, []);

    return (
        <div>
            <Row justify="space-between" style={{ marginBottom: 20, justifyContent: 'center', }}>
                <Col xs={22} sm={16} md={12} lg={9}>
                    <Card>
                        <Form style={{ padding: 15 , textAlign: 'center'}}
                            form={form}
                            name="user-details-form"
                            onFinish={handleSubmit}
                            layout="vertical"
                        >
                            <Form.Item
                                label="Select Business Category"
                                name="category_id"
                                rules={[
                                    { required: true, message: "Please select business category!" },
                                ]}
                            >
                                <Select
                                    showSearch
                                    placeholder="Select a category"
                                    filterOption={(input, option) =>
                                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                    }
                                    className='category-select'
                                    size='large'
                                    options={listingCategory.map((op) => ({
                                        value: op.id, // Replace `id` with the appropriate key from your API response
                                        label: op.name, // Replace `name` with the appropriate key from your API response
                                    }))}
                                    onChange={handleCategoryChange}
                                />
                            </Form.Item>

                            {(selectedCategory && subCategory.length > 0) && (
                                <Form.Item
                                    label="Select Business Sub-Category"
                                    name="sub_category_id"
                                    rules={[{ required: true, message: "Please select business sub-category!" }]}
                                >
                                    <Select
                                        showSearch
                                        placeholder="Select a sub-category"
                                        filterOption={(input, option) =>
                                            (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                                        }
                                        className="category-select"
                                        size="large"
                                        options={subCategory.map(op => ({
                                            value: op.id,
                                            label: op.name,
                                        }))}
                                        onChange={handleSubCategoryChange}
                                    />
                                </Form.Item>
                            )}

                            <Form.Item
                                label="Business Name"
                                name="business_name"
                                rules={[
                                    { required: true, message: "Please enter your business name!" }
                                ]}
                            >
                                <Input placeholder="Enter your business name" />
                            </Form.Item>

                            <Form.Item
                                label="Business Description"
                                name="description"
                                rules={[
                                    { required: true, message: "Please enter your business description!" }
                                ]}
                            >
                                <Input.TextArea placeholder="Enter your business description" rows={4} />
                            </Form.Item>

                            <Form.Item
                                label="Contact Name"
                                name="contact_name"
                                rules={[
                                    { required: true, message: "Please enter your business name!" }
                                ]}
                            >
                                <Input placeholder="Enter your business name" />
                            </Form.Item>

                            <Form.Item
                                label="Contact Number"
                                name="contact_no"
                                rules={[
                                    { required: true, message: "Please enter your business name!" }
                                ]}
                            >
                                {/* <Input placeholder="Enter your business name" /> */}
                                <Input
                                    placeholder='(+91) - Contact Number'
                                    maxLength={10}
                                />
                            </Form.Item>

                            <Form.Item
                                label="Business Address"
                                name="address"
                                rules={[{ required: true, message: "Please enter your business address!" }]}
                            >
                                <ReactGoogleAutocomplete
                                    apiKey="AIzaSyDTZlQB2hhTNQe_IjSE2T9a8VkKVkxExxc"
                                    onPlaceSelected={handlePlaceSelected}
                                    options={{
                                        types: ["address"],
                                        componentRestrictions: { country: "in" },
                                    }}
                                    className="ant-input"
                                    placeholder="Enter your business address"
                                />
                            </Form.Item>

                            <Form.Item
                                label="Select Established Year"
                                name="establed_at"
                                rules={[
                                    { required: true, message: "Please select established year!" },
                                ]}
                            >
                                <Select
                                    placeholder="Select a year"
                                    className='category-select'
                                    size='large'
                                    options={years.map((op) => ({
                                        value: op,
                                        label: op,
                                    }))}
                                />
                            </Form.Item>

                            <Form.Item
                                label="Discount Offer (Optional)"
                                name="discount"
                            >
                                <Input placeholder='Enter your discount offer' />
                            </Form.Item>

                            {(selectedCategory && services.length > 0) && (
                                <>
                                    <Form.Item
                                        label="Services you provide"
                                        name="services"
                                        rules={[
                                            { required: true, message: "Please select established year!" },
                                        ]}
                                    >
                                        <Select
                                            mode="multiple"
                                            placeholder="Select your services"
                                            className='services'
                                            size='large'
                                            options={services.map((op) => ({
                                                value: op.id,
                                                label: op.service,
                                            }))}
                                        />
                                    </Form.Item>
                                </>
                            )}

                            <Form.Item label="Upload Logo" name="logo" valuePropName="fileList" rules={[{ required: true, message: "Required field missing" }]} getValueFromEvent={(e) => normFile(e, setLogo)}>
                                <Upload listType="picture-card" beforeUpload={() => false} maxCount={1}>
                                    <PlusOutlined /> Upload
                                </Upload>
                            </Form.Item>

                            <Form.Item label="Aadhar Card (Front)" name="aadhar_front" valuePropName="fileList" rules={[{ required: true, message: "Required field missing" }]} getValueFromEvent={(e) => normFile(e, setAadharFront)}>
                                <Upload listType="picture-card" beforeUpload={() => false} maxCount={1}>
                                    <PlusOutlined /> Upload
                                </Upload>
                            </Form.Item>

                            <Form.Item label="Aadhar Card (Back)" name="aadhar_back" valuePropName="fileList" rules={[{ required: true, message: "Required field missing" }]} getValueFromEvent={(e) => normFile(e, setAadharBack)}>
                                <Upload listType="picture-card" beforeUpload={() => false} maxCount={1}>
                                    <PlusOutlined /> Upload
                                </Upload>
                            </Form.Item>

                            <Form.Item label="PAN Card" name="pan_card" valuePropName="fileList" rules={[{ required: true, message: "Required field missing" }]} getValueFromEvent={(e) => normFile(e, setPanCard)}>
                                <Upload listType="picture-card" beforeUpload={() => false} maxCount={1}>
                                    <PlusOutlined /> Upload
                                </Upload>
                            </Form.Item>

                            <Form.Item label="Shop Photos" name="shop_photos" valuePropName="fileList" rules={[{ required: true, message: "Required field missing" }]} getValueFromEvent={normMultipleFiles}>
                                <Upload listType="picture-card" beforeUpload={() => false} multiple>
                                    <PlusOutlined /> Upload
                                </Upload>
                            </Form.Item>

                            <Form.Item>
                                <Button type="primary" htmlType="submit" style={{ backgroundColor: '#a6cc43', borderColor: '#a6cc43', color: '#FFFFFF' }}>
                                    Submit
                                </Button>
                            </Form.Item>
                        </Form>
                    </Card>
                </Col>

                <Col xs={22} sm={16} md={12} lg={14}>
                    <List
                        itemLayout="vertical"
                        size="large"
                        loading={loading}
                        pagination={{
                            onChange: (page) => {
                                console.log(page);
                            },
                            pageSize: 5,
                        }}
                        dataSource={data}
                        renderItem={(item) => (
                            <Card
                                className="mb-4 p-4 shadow-md rounded-lg"
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "16px",
                                }}
                            >
                                <List.Item
                                    key={item.id}
                                    style={{
                                        display: "flex",
                                        flexWrap: "wrap", // Wrap content on smaller screens
                                        gap: "20px",
                                        alignItems: "center",
                                    }}
                                >
                                    {/* Business Logo */}
                                    <img
                                        alt={item.business_name}
                                        src={`${url}/${item.logo}`} // Dynamic image URL
                                        style={{
                                            width: "120px", // Default image size
                                            height: "120px",
                                            objectFit: "cover",
                                            borderRadius: "10px",
                                            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                                        }}
                                    />

                                    {/* Business Details */}
                                    <div
                                        style={{
                                            flex: 1,
                                            minWidth: "250px", // Ensures text doesn't get squished
                                        }}
                                    >
                                        <List.Item.Meta
                                            title={
                                                <a
                                                    href={item.href}
                                                    style={{
                                                        fontSize: "18px",
                                                        fontWeight: "600",
                                                        color: "#333",
                                                        textDecoration: "none",
                                                    }}
                                                >
                                                    {item.business_name}
                                                </a>
                                            }
                                            description={
                                                <>
                                                    {/* Sub-category */}
                                                    <p
                                                        style={{
                                                            margin: 0,
                                                            fontSize: "14px",
                                                            color: "#666",
                                                        }}
                                                    >
                                                        {item.sub_category?.name}
                                                    </p>

                                                    {/* City */}
                                                    <p
                                                        style={{
                                                            margin: "5px 0",
                                                            fontSize: "14px",
                                                            fontWeight: "500",
                                                        }}
                                                    >
                                                        📍 {item.city}
                                                    </p>

                                                    <p
                                                        style={{
                                                            margin: "5px 0",
                                                            fontSize: "14px",
                                                            fontWeight: "500",
                                                        }}
                                                    >
                                                        <span style={{ color: item.status === 1 ? "green" : "orange" }}>{item.status === 1 ? 'Visible' : 'Under Verfication'}</span>
                                                    </p>

                                                    {/* Rating */}
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            gap: "8px",
                                                        }}
                                                    >
                                                        <Rate
                                                            allowHalf
                                                            disabled
                                                            defaultValue={parseFloat(item.avg) || 0} // Average rating
                                                            style={{ fontSize: "16px" }}
                                                        />
                                                        <span
                                                            style={{
                                                                fontSize: "14px",
                                                                color: "#666",
                                                            }}
                                                        >
                                                            ({item.avg || "No Ratings"})
                                                        </span>
                                                    </div>
                                                </>
                                            }
                                        />
                                    </div>

                                    {/* Action Buttons */}
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            gap: "10px",
                                            justifyContent: "center",
                                            flexWrap: "wrap", // Wrap buttons on smaller screens
                                            minWidth: "150px",
                                        }}
                                    >
                                        <Button
                                            type="primary"
                                            // icon={<PhoneFilled />}
                                            onClick={() => navigate("/user/business-dashboard", { state: { business: item, url } })}
                                            className="form-btn"
                                            style={{
                                                fontSize: "14px",
                                                width: "100%", // Full width for small screens
                                            }}
                                        >
                                            View Details
                                        </Button>
                                    </div>
                                </List.Item>
                            </Card>
                        )}
                    />
                </Col>
            </Row>
        </div>
    )
}

export default ListBusiness